export default "__VITE_ASSET__CFxL8qfy__"